/* ==========================================================================
   THEME.JS — small, dependency-free behaviors shared across sections.
   ========================================================================== */
(function () {
  'use strict';

  /* ---------------- Mobile nav ---------------- */
  function initMobileNav() {
    var burger = document.querySelector('[data-burger-open]');
    var closeBtn = document.querySelector('[data-burger-close]');
    var nav = document.querySelector('[data-mobile-nav]');
    var overlay = document.querySelector('[data-mobile-nav-overlay]');
    if (!burger || !nav) return;

    function open() {
      nav.classList.add('is-open');
      document.body.classList.add('nav-open');
    }
    function close() {
      nav.classList.remove('is-open');
      document.body.classList.remove('nav-open');
    }
    burger.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (overlay) overlay.addEventListener('click', close);
  }

  /* ---------------- Cart drawer ---------------- */
  var CartDrawer = {
    el: null,
    overlay: null,
    body: null,

    init: function () {
      this.el = document.querySelector('[data-cart-drawer]');
      this.overlay = document.querySelector('[data-cart-drawer-overlay]');
      this.body = document.querySelector('[data-cart-drawer-body]');
      if (!this.el) return;

      document.addEventListener('click', function (e) {
        var openTrigger = e.target.closest('[data-cart-open]');
        var closeTrigger = e.target.closest('[data-cart-close]');
        if (openTrigger) {
          e.preventDefault();
          CartDrawer.open();
        }
        if (closeTrigger) {
          e.preventDefault();
          CartDrawer.close();
        }
      });

      document.addEventListener('submit', function (e) {
        var form = e.target.closest('form[data-add-to-cart-form]');
        if (!form) return;
        e.preventDefault();
        CartDrawer.addItem(form);
      });
    },

    open: function () {
      this.el.classList.add('is-open');
      document.body.classList.add('cart-drawer-open');
    },
    close: function () {
      this.el.classList.remove('is-open');
      document.body.classList.remove('cart-drawer-open');
    },

    addItem: function (form) {
      var formData = new FormData(form);
      var submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn) submitBtn.setAttribute('disabled', 'disabled');

      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(function (res) { return res.json(); })
        .then(function () {
          return fetch('/cart.js');
        })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          CartDrawer.render(cart);
          CartDrawer.open();
        })
        .catch(function (err) { console.error('Add to cart failed', err); })
        .finally(function () {
          if (submitBtn) submitBtn.removeAttribute('disabled');
        });
    },

    render: function (cart) {
      var countEls = document.querySelectorAll('[data-cart-count]');
      countEls.forEach(function (el) { el.textContent = cart.item_count; });

      if (!this.body) return;
      if (!cart.items.length) {
        this.body.innerHTML = '<div class="cart-drawer__empty"><p>Your cart is empty.</p></div>';
        return;
      }
      var html = '';
      cart.items.forEach(function (item) {
        html += '' +
          '<div class="cart-drawer__item">' +
            '<div class="cart-drawer__item-image"><img src="' + item.image + '" alt="' + item.product_title + '" loading="lazy"></div>' +
            '<div class="cart-drawer__item-detail">' +
              '<span class="cart-drawer__item-name">' + item.product_title + '</span>' +
              '<span class="cart-drawer__item-price">' + formatMoney(item.final_price) + ' &times; ' + item.quantity + '</span>' +
            '</div>' +
          '</div>';
      });
      this.body.innerHTML = html;

      var subtotalEl = document.querySelector('[data-cart-subtotal]');
      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    }
  };

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  /* ---------------- Accordions (FAQ) ---------------- */
  function initAccordions() {
    document.querySelectorAll('[data-accordion-trigger]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('[data-accordion-item]');
        if (!item) return;
        item.classList.toggle('is-open');
      });
    });
  }

  /* ---------------- Play / pause media ---------------- */
  function initMediaToggles() {
    document.querySelectorAll('[data-media-toggle]').forEach(function (btn) {
      var wrapper = btn.closest('[data-media-wrapper]');
      if (!wrapper) return;
      var video = wrapper.querySelector('video');
      if (!video) return;

      btn.addEventListener('click', function () {
        if (video.paused) {
          video.play();
          btn.classList.add('is-playing');
        } else {
          video.pause();
          btn.classList.remove('is-playing');
        }
      });
    });
  }

  /* ---------------- Hero gallery ---------------- */
  function initGalleries() {
    document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
      var mainImages = gallery.querySelectorAll('[data-gallery-main] img');
      var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
      thumbs.forEach(function (thumb, i) {
        thumb.addEventListener('click', function () {
          thumbs.forEach(function (t) { t.classList.remove('is-active'); });
          mainImages.forEach(function (img) { img.classList.remove('is-active'); });
          thumb.classList.add('is-active');
          if (mainImages[i]) mainImages[i].classList.add('is-active');
        });
      });
    });
  }

  /* ---------------- Expert flip cards ---------------- */
  function initExpertCards() {
    document.querySelectorAll('[data-expert-card]').forEach(function (card) {
      card.addEventListener('click', function () {
        card.classList.toggle('is-flipped');
      });
    });
  }

  /* ---------------- Bundle option selection (hero product) ---------------- */
  function initBundleOptions() {
    document.querySelectorAll('[data-bundle-options]').forEach(function (wrap) {
      var inputs = wrap.querySelectorAll('input[type="radio"]');
      var priceEl = document.querySelector('[data-atc-price]');
      inputs.forEach(function (input) {
        input.addEventListener('change', function () {
          wrap.querySelectorAll('.bundle-option').forEach(function (opt) { opt.classList.remove('is-selected'); });
          var option = input.closest('.bundle-option');
          if (option) option.classList.add('is-selected');
          if (priceEl && input.dataset.price) priceEl.textContent = input.dataset.price;

          var form = wrap.closest('form');
          if (form && input.dataset.variantId) {
            var idField = form.querySelector('input[name="id"]');
            if (idField) idField.value = input.dataset.variantId;
          }
        });
      });
    });
  }

  /* ---------------- Simple horizontal-scroll carousel nav buttons ---------------- */
  function initCarouselNav() {
    document.querySelectorAll('[data-carousel]').forEach(function (carousel) {
      var track = carousel.querySelector('[data-carousel-track]');
      var prev = carousel.querySelector('[data-carousel-prev]');
      var next = carousel.querySelector('[data-carousel-next]');
      if (!track) return;

      function scrollByCard(dir) {
        var card = track.querySelector(':scope > *');
        var amount = card ? card.getBoundingClientRect().width + 20 : 300;
        track.scrollBy({ left: dir * amount, behavior: 'smooth' });
      }
      if (prev) prev.addEventListener('click', function () { scrollByCard(-1); });
      if (next) next.addEventListener('click', function () { scrollByCard(1); });
    });
  }

  /* ---------------- Sticky buy bar ---------------- */
  function initStickyBuyBar() {
    var bar = document.querySelector('[data-sticky-buy-bar]');
    var hero = document.querySelector('[data-hero-product]');
    if (!bar || !hero) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          bar.classList.remove('is-visible');
        } else if (entry.boundingClientRect.top < 0) {
          bar.classList.add('is-visible');
        } else {
          bar.classList.remove('is-visible');
        }
      });
    }, { threshold: 0 });
    observer.observe(hero);

    var scrollBtn = bar.querySelector('[data-scroll-to-hero]');
    if (scrollBtn) {
      scrollBtn.addEventListener('click', function () {
        hero.scrollIntoView({ behavior: 'smooth' });
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    initMobileNav();
    CartDrawer.init();
    initAccordions();
    initMediaToggles();
    initGalleries();
    initExpertCards();
    initBundleOptions();
    initCarouselNav();
    initStickyBuyBar();
  });
})();
